import {APIService} from "../../common/APIService";
import {ZipcodeZone} from "../../dto/ZipcodeZone";

export class ZipcodeZoneService extends APIService {
  public async browseZipcodeZones() {
    const json = await this.getJson<{data: object[]}>('zipcode-zones')
    return json.data.map((item) => ZipcodeZone.fromJson(item))
  }

  public async read(id: string) {
    const json = await this.getJson<{data: object}>(`zipcode-zones/${id}`)
    return ZipcodeZone.fromJson(json.data)
  }

  public async add(name: string, zipcodesFrom: number, zipcodesTo: number) {
    const json = await this.postJson<{data: object[]}>('zipcode-zones', {
      name: name,
      zipcodes_from: zipcodesFrom,
      zipcodes_to: zipcodesTo,
    })
    return ZipcodeZone.fromJson(json.data)
  }

  public async edit(zipcodeZoneId: string, name: string, zipcodesFrom: number, zipcodesTo: number) {
    const json = await this.putJson<{data: object[]}>(`zipcode-zones/${zipcodeZoneId}`, {
      name: name,
      zipcodes_from: zipcodesFrom,
      zipcodes_to: zipcodesTo,
    })
    return ZipcodeZone.fromJson(json.data)
  }

  public async delete(zipcodeZoneId: string) {
    await this.deleteJson(`zipcode-zones/${zipcodeZoneId}`)
  }
}